
  <div class="common-header-flex">
    <div>{{title}}</div>
    <button>
      <span (click)="closeModal()" class="common-close">&times;</span>
    </button>
  </div>

<div class="modal-body">

    <ng-container>
        <div class="row">
            <div class="col-lg-6 form-group" *ngFor="let item of fields">
                <label>{{item.label}}</label>
                <input *ngIf="item?.type === 'STRING'" class="form-control" type="text" [value]="(item.value === null || item.value === undefined) ? 'N/A' :item.value " [disabled]="true">
                <input *ngIf="item?.type === 'DATE'"
                        class="form-control" type="text" [value]="item.value && item.value !== 'N/A' ? (item.value | timezoneDate: 'MM/dd/yyyy') : 'N/A'" [disabled]="true">
                <ng-container *ngIf="item?.type === 'LIST' && item?.value">
                  <div class="inputbox">
                    <textarea #networkTextarea [disabled]="true" class="form-control custom-textbox" [value]="getFormattedValues(item?.value)"></textarea>
                  </div>
                </ng-container>
            </div>

            <!-- Contract Roles — full width, part of the same form grid -->
            <div class="col-lg-12 form-group" *ngIf="showContractRoles">
                <label>Contract Roles</label>
                <ng-select
                  [items]="contractRolesList"
                  bindLabel="label"
                  bindValue="value"
                  [multiple]="true"
                  [hideSelected]="false"
                  [closeOnSelect]="false"
                  appendTo="body"
                  placeholder="Select contract roles"
                  [(ngModel)]="selectedRoles">
                  <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                    <div class="ng-select-checkbox-label">
                      <span class="ng-select-checkmark" [class.checked]="item$.selected"></span>
                      <span class="ng-select-checkbox-text">{{item.label}}</span>
                    </div>
                  </ng-template>
                </ng-select>
            </div>
        </div>
    </ng-container>

</div>

<div class="modal-footer text-center">
    <button type="button" class="btn btn-default" (click)="closeModal()">Cancel</button>
    <button type="button" class="btn btn-primary" *ngIf="showContractRoles"
      (click)="saveContractRoles()" [disabled]="!hasRoleChanges || saving">
      <ng-icon name="tablerLoader2" class="spin" *ngIf="saving"></ng-icon>
      Save
    </button>
</div>

